import { NavLink } from "react-router-dom";
import { Home, Megaphone, ReceiptText, UserRound } from "lucide-react";

export const NAV_ITEMS = [
  { id: "home", to: "/", label: "Home", icon: Home },
  { id: "orders", to: "/orders", label: "Orders", icon: ReceiptText },
  { id: "smm", to: "/smm", label: "SMM", icon: Megaphone, dot: true },
  { id: "profile", to: "/profile", label: "Profile", icon: UserRound },
];

export default function BottomNav() {
  return (
    <nav aria-label="Main navigation" className="fixed inset-x-0 bottom-0 z-50 w-full border-t border-ts-border bg-white pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_20px_rgba(10,36,214,0.06)] md:hidden" data-testid="bottom-nav">
      <div className="flex h-16 w-full items-stretch justify-around" data-testid="bottom-nav-items">
        {NAV_ITEMS.map(({ id, to, label, icon: Icon, dot }) => (
          <NavLink key={id} to={to} end={to === "/"} data-testid={`bottom-nav-${id}`} className="relative flex flex-1 flex-col items-center justify-center gap-1 transition-transform duration-150 active:scale-95">
            {({ isActive }) => (
              <>
                <span className={`relative grid h-8 w-12 place-items-center rounded-lg transition-colors duration-200 ${isActive ? "bg-ts-blue-soft" : ""}`}>
                  <Icon className={`h-5 w-5 ${isActive ? "text-ts-blue" : "text-ts-muted"}`} strokeWidth={isActive ? 2.4 : 2} />
                  {dot && <span className="absolute right-2 top-1 h-2 w-2 rounded-full bg-ts-red ring-2 ring-white" />}
                </span>
                <span className={`text-[10px] font-semibold ${isActive ? "text-ts-blue" : "text-ts-muted"}`}>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
